class RequestRepairCountry {
  constructor() {
    this.selectors = {
      countryOptions: '.state option',
    };
  }

  countryAlternateValues() {
    const countryOptions = document.querySelector(this.selectors.countryOptions);
    const countryOptionValues = countryOptions.getAttribute('data-provinces');
    const countryOptionItems = countryOptionValues.split(',');
    countryOptionItems.forEach((item, index) => {
      const skipDup = index % 2 === 0;
      if (skipDup === false) {
        const optionTag = document.createElement('option');
        const optionTagValue = document.createTextNode(item.replace(/[^a-zA-Z ]/g, ''));
        optionTag.appendChild(optionTagValue);
        document.getElementById('ContactForm-country').appendChild(optionTag);
      }
    });
  }

  init() {
    this.countryAlternateValues();
  }
}

document.addEventListener('DOMContentLoaded', () => new RequestRepairCountry().init());
